<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem>APP管理</BreadcrumbItem>
        <BreadcrumbItem>拍客列表</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <!-- <Row xs="20" sm="16" md="12" lg="8">

			<Col span='4'>
			  <Input v-model="searchParam.msgContent" placeholder="" />
			</Col>

			<Col span='1'>
			<Button type="info" @click='searchData'>查询</Button>
			</Col>
			<ul class='conheadRight'>
				<i-button type="error" @click='gethtDetail(-1)'>新增拍客</i-button>
			</ul>
		</Row> -->
    <Row xs="20" sm="16" md="12" lg="8">
      <Col span="5">
      <DatePicker type="daterange" @on-change='getDateData' :split-panels='true' placement='bottom-start'
        placeholder="日期区间（默认当天）" style='width:100%;margin-left:1px'></DatePicker>
      </Col>
      <Col span='4'>
      <Input v-model="msg" placeholder="拍客标题" />
      </Col>
      <Col span='2'>
      <Input v-model="addname" placeholder="作者" />
      </Col>
      <Col span='4'>
      <Button type="info" @click='searchData' style='margin: 0px 10px;'>查询</Button>
      <Button type="warning" class='downcsv' @click='exportTotalData'>导出</Button>
      </Col>



    </Row>
    <Row id='pdData'>
      <div v-for='(item, index) in pdData' class='itempd' :class='[index == curIndex ? "active" : ""]'
        @click='tabPD(index, item)'>{{ item.name }}</div>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :emitrow='emitrow' :randomrow='randomrow' :searchParam='searchParam'
        :issearch='issearch' @smodal='sModal'></tablePage>
    </section>


    <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
    <Modal v-model="editht" title='话题修改' width='700px' :mask-closable='false'>
      <Form :model="formItem" :label-width="120">
        <section id='con'>
          <Form-item label="话题">
            <Select v-model="formItem.classid">
              <Option v-for='(items, indexs) in pdData' :key='indexs' :value="items.guid">
                {{ items.name }}
              </Option>
            </Select>
          </Form-item>
          <Form-item label="类型">
            <RadioGroup v-model="formItem.type">
              <Radio label="0">照片</Radio>
              <Radio label="1">视频</Radio>
            </RadioGroup>
          </Form-item>
          <FormItem label="照片" v-if='formItem.type == 0'>
            <input type="hidden" v-model='formItem.pics'>
            <upImg @upImglist='upImglist' :extradata='pictype' :defaultimg='formItem.pics' :datanum='treekey'
              :max-len='piclen'></upImg>

          </FormItem>
          <FormItem label="视频" v-if='formItem.type == 1'>
            <video id="myvideo" width="350" height="196" :src="videoUrl" controls="controls" style="display:inline;">
              <source id="tv" type="video/mp4" :src="videoUrl">
              视频
              </source>
              您的浏览器不支持video标签
            </video>
            <Upload :action="actionUrl" :on-success='upVideo' ref="videoUpload">
              <Button icon="ios-cloud-upload-outline">上传视频</Button>
            </Upload>
          </FormItem>
          <FormItem label="视频封面图片" v-if='formItem.type == 1'>
            <input type="hidden" v-model='formItem.videothum'>
            <upImg @upImglist='upImglist' :extradata='pictype' :defaultimg='formItem.videothum' :datanum='treekey'
              :max-len='videolen'></upImg>

          </FormItem>
          <!-- <FormItem label="上传">
                  

                      <Upload  ref="upload" :on-success='fileSUccess' type="drag" :action="upurl">
                            <div style="padding: 20px 0">
                                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                                <p>点击或拖拽文件到这里上传</p>
                            </div>
                        </Upload>
                  </FormItem>
                  <p v-if='formItem.type==1' style='color:orangered'>请继续上传视频播放封面图片</p> -->
          <FormItem label="标题">
            <Input v-model="formItem.msgContent" placeholder="请输入"></Input>
          </FormItem>
        </section>
      </Form>

      <div slot="footer" style='position:relative;clear:both'>

        <Button type="error" @click='removeItem' class='remove' icon="md-trash"
          v-if='this.formItem.guid != ""'>删除</Button>
        <Button type="default" @click='editht = false' icon="md-close">取消</Button>
        <Button type="info" @click='postNews(true)' icon="md-checkmark-circle-outline">保存</Button>
      </div>

    </Modal>
  </section>
</template>

<script>
import getDates from '../utils/index'
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
import upImg from './upImg'
import { exprotTable } from '../utils/xlstable.js'
export default {
  name: 'noticelist',
  components: {
    tablePage,
    bemodal,
    upImg
  },
  data () {
    return {
      pictype: {
        type: 'pkphoto',
        size: '无限制'
      },
      formItem: {
        classid: '',
        msgContent: '',
        lon: '',
        lat: '',
        small: '',
        pics: '',
        video: '',
        videothum: '',
        imggeratio: '',
        location: '',
        type: '0',
        guid: '',
      },
      videoUrl: '',
      piclen: 9,
      videolen: 1,
      treekey: -1,
      editht: false,
      edit: false,
      ispdsearch: -1,
      pdData: [],
      smodal: false,
      reloadpdTmep: -1,
      reloadTmep: -1,
      initformData: [],
      curSonItem: {},

      formData: [
        ['circleManager/getId', 'circleManager/save', 'circleManager/delete'],
        [{
          type: 'pkselect',
          title: '话题',
          name: 'classid',
          model: '',
          children: []
        }, {
          type: 'input',
          title: '标题',
          name: 'msgContent',
          model: '',
        },
        {
          type: 'upImgnew',
          title: '照片',
          name: 'pics',
          len: 9,
          pictype: {
            type: 'pkphoto',
            size: '无限制'
          },
          model: '',

        },
        {
          type: 'uploadimg',
          title: '背景图',
          name: 'pic',
          pictype: {
            type: 'videobg'
          },
          model: '',
        },
        {
          type: 'video',
          title: '视频',
          name: 'url',
          pictype: {
            type: 'video'
          },
          model: ''
        },

        // {
        // 	type: 'input',
        // 	title: '超链接',
        // 	name: 'url',
        // 	model: ''
        // },
        // {type:'checkbox',title:'显示方式',children:[{name:'unshared',title:'独占方式显示（遮挡所有画面）',model:true}]},
        // {
        // 	type: 'video',
        // 	title: '视频',
        // 	name: 'url',
        // 	pictype: {
        // 		type: 'video'
        // 	},
        // 	model: ''
        // },
        // {
        // 	type: 'uploadimg',
        // 	title: '视频背景图',
        // 	name: 'videothum',
        // 	pictype: {
        // 		type: 'videobg',
        // 	},
        // 	model: '',

        // },
        {
          type: 'hidden',
          children: [{
            name: 'guid',
            model: ''
          },
          { name: 'small', model: '' },
          { name: 'lon', model: '' },
          { name: 'lat', model: '' },
          { name: 'imageratio', model: '' },
          { name: 'location', model: '' },
          { name: 'video', model: '' },
          { name: 'videothum', model: '' },
          ]
        }
        ]
      ],

      queryData: ['',
        [{
          title: '标题',
          key: 'msgContent',
          render: (h, params) => {
            return h('span', decodeURIComponent(params.row.msgContent))
          }
        },

        {
          title: '拍客',
          key: '',
          width: 160,
          align: 'center',
          ellipsis: true,
          render: (h, params) => {
            return h('span', decodeURIComponent(params.row.name))
            var pic = params.row.pic ? params.row.pic : 'https://wjdayly.obs.cn-jssz1.ctyun.cn/img_head_portrait.png'
            var name = params.row.name ? params.row.name : ''

            var _firstLetter = params.row.name.substr(0, 1)
            var test2 = params.row.test2
            return h('viewer', [
              h('img', {
                style: { //设置样式
                  display: 'inline-block',
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  textAlign: 'center',
                  lineHeight: '30px',
                  position: 'absolute',
                },
                attrs: { //设置属性
                  src: pic
                }
              }),
              h('span', {
                style: {
                  fontWeight: 'bold',
                  width: '30px',
                  height: '30px',
                  paddingLeft: '45px',
                  lineHeight: '30px',
                },
              }, decodeURIComponent(params.row.name))
            ])
          }
        },
        {
          title: '发布时间',
          key: 'addtime',
          align: 'center',
        },
        {
          title: '点赞数',
          key: 'likecnt',
          width: 100,
          align: 'center',
        },

        {
          title: '拍客内容',
          key: '',
          align: 'center',
          render: (h, params) => {
            var styles = {//设置样式
              display: 'inline-block',
              width: '50px',
              height: '50px',
              borderRadius: '3px',
              textAlign: 'center',
              lineHeight: '50px',
              marginRight: '3px'
            }

            if (!params.row.video) {
              var _pics = params.row.pics.split(',')
              var imgs = []
              _pics.map(function (val, index) {
                imgs.push(h('img', { style: styles, attrs: { src: val } }))
              })

              return h('viewer', imgs)
            } else {
              return h('video', { style: { width: '150px', height: '100px' }, attrs: { controls: "controls" } }, [h('source', { style: { width: '50px', height: '50px' }, attrs: { src: params.row.video } })])
            }


          }
        },
        {
          title: '操作',
          width: 90,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '60px',
                  height: '25px',
                  background: '#2db7f5',
                  borderRadius: '6px',
                  textAlign: 'center',
                  lineHeight: '25px',
                  color: '#fff',
                  fontSize: '12px',
                  cursor: 'pointer',
                  userSelect: 'none'
                },
                on: {
                  click: () => {


                    this.gethtDetail(params.row.guid, params.row)
                    // user.isPrincipal = user.isPrincipal == 1 ? true : false
                    // user.state = user.state == 1 ? true : false


                  }
                }
              }, '编辑')
            ])

          }
        }

        ]
      ],
      searchParam: {
        name: '',
        begintime: '',
        endtime: '',
        msgContent: '',
      },
      msg: '',
      issearch: -1,
      curIndex: 0,
      emitrow: {},
      randomrow: -1,
      upurl: '',
      actionUrl: '',
      storeimg: [],
      curTabName: '',
      addname: '',
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
    this.actionUrl = this.upurl = this.baseURL.imgURL
    this.getpdData()
  },
  methods: {
    exportTotalData () {
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>正在下载数据，可能需要一定时间，请关注浏览器下载完成的信息提示</p>',
        onOk: () => {

        },
        onCancel: () => {

        }
      });
      var param = this.searchParam
      param['length'] = -1
      param['status'] = -1
      console.log(param, 'param')

      this.axios.get('circleManager/getQueryList', { params: param }).then(res => {
        console.log(res)
        var tHeader = ['标题', '类别', '拍客', '点赞数', '发布时间', '拍客内容']

        var _data = res.data
        var arr = []
        _data.map(function (val, index) {
          val['lb'] = that.curTabName


          arr.push({ msgContent: decodeURIComponent(val['msgContent']), lb: that.curTabName, name: decodeURIComponent(val['name']), likecnt: val['likecnt'], addtime: "&nbsp;" + String(val['addtime']) + "&nbsp;", pics: val['pics'] })
        })

        exprotTable(tHeader, arr, '拍客内容')

      })
    },
    getDateData (a, b) {

      this.searchParam.begintime = a[0]
      this.searchParam.endtime = a[1]
    },
    postNews (flag) {
      console.log(this.formItem)
      console.log(this.storeimg)
      var that = this
      var param = {
        msgContent: this.formItem.msgContent,
        pics: '',
        classid: this.formItem.classid,
        small: '',
        video: '',
        videothum: '',
        lon: this.formItem.lon,
        lat: this.formItem.lat,
        imageratio: this.formItem.imageratio,
        location: this.formItem.location,
        guid: this.formItem.guid,
      }
      if (this.formItem.type == 0) {
        console.log('图片')
        param['pics'] = that.formItem.pics
        param['small'] = that.formItem.small
        var storeImg = that.storeimg
        var smallpic = []
        var pics = []
        if (that.storeimg && that.storeimg.length > 0) {
          for (var i = 0; i < that.storeimg.length; i++) {
            smallpic.push(that.storeimg[i]['picsmall'])
            pics.push(that.storeimg[i]['pic'])
          }
          param['pics'] = pics.join(',')
          param['small'] = smallpic.join(',')
        } else {
          param['pics'] = that.formItem.pics
          param['small'] = that.formItem.small
        }

        param['video'] = ''
        param['videothum'] = ''
      } else {
        if (this.videoUrl) {
          param['pic'] = ''
          param['small'] = ''
          param['video'] = this.videoUrl
          if (that.storeimg && that.storeimg.length > 0) {
            for (var i = 0; i < that.storeimg.length; i++) {
              param['videothum'] = that.storeimg[i]['pic']
            }
          }

        } else {
          param['video'] = this.formItem.video
          param['videothum'] = this.formItem.videothum
        }
        console.log('视频')
        if (param['video'] == '') {
          that.$Message.info('请上传视频')
          return false
        }
        if (param['videothum'] == '') {
          that.$Message.info('请上传视频封面')
          return false
        }
      }

      console.log(param)
      that.axios.post('circleManager/save', param).then(res => {
        console.log(res,)
        if (res.success) {
          that.$Message.info(res.msg)
          that.editht = false
          that.searchData()
        } else {
          that.$Message.warning(res.msg)
        }
      })


    },
    removeItem () {
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除</p>',
        onOk: () => {
          this.axios.post('circleManager/delete', { id: that.formItem.guid }).then(res => {
            ////console.log(res)
            that.$Message.info(res.msg)
            that.editht = false
            that.searchData()
          }).catch(function (err) {
            that.$Message.error(err.msg)
          })

        },
        onCancel: () => {

        }
      })
    },
    gethtDetail (guid, param) {
      console.log(guid, param)
      this.editht = true
      var that = this
      if (guid != -1) {
        that.axios.get('circleManager/getId', {
          params: { id: guid }
        }).then((mock) => {
          console.log(mock)
          if (mock.success) {
            var mockData = mock.data
            mockData['type'] = mock.data.video ? '1' : '0'
            mockData['msgContent'] = decodeURIComponent(mockData['msgContent'])
            that.videoUrl = mockData.video
            that.formItem = mockData
          } else {
            that.$message.info(mock.msg)
          }
        })
      } else {
        that.formItem = {
          classid: '',
          msgContent: '',
          lon: '',
          lat: '',
          small: '',
          pics: '',
          video: '',
          videothum: '',
          imageratio: '',
          location: '',
          type: '0',
          guid: '',
        }
      }


    },
    upImglist (a, b, c) {
      console.log(a, b, c)
      var _name = a.name
      var pics = a.pics
      var arr = []
      for (var i = 0; i < pics.length; i++) {
        var item = pics[i]['response']['url']
        var pic = item.split("@")[1]
        var picsmall = item.split("@")[0]
        var obj = {
          pic: pic,
          picsmall: picsmall,
        }
        arr.push(obj)
      }

      // var storeImg = this.storeimg
      // if (storeImg.length > 0) {
      // 	for (var j = 0; j < storeImg.length; j++) {
      // 		switch (storeImg[j]['name']) {
      // 			case _name:
      // 				storeImg[j]['children'] = arr
      // 				break;
      // 			default:
      // 				storeImg.push({
      // 					name: _name,
      // 					children: arr
      // 				})
      // 				break;
      // 		}
      // 	}
      // } else {
      // 	storeImg.push({
      // 		name: _name,
      // 		children: arr
      // 	})
      // }
      this.storeimg = arr

    },
    upVideo (a, b, c) {
      ////console.log(this.$refs['videoUpload'][0].fileList, this.$refs['videoUpload'][0].fileList.length)
      // if (this.$refs['videoUpload'][0].fileList.length > 1) {
      // 	this.$refs['videoUpload'][0].fileList.splice(0, 1)
      // }
      //this.$refs['videoUpload'][0].clearFiles()
      this.videoUrl = a.url
    },
    fileSUccess (a, b, c) {
      var _url = a.url.split('.')
      var newurl = _url[_url.length - 1]

      var tupian = getfiletype(newurl)
      this.hadposter = tupian
      function getfiletype (ext) {
        if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1) {
          return 0
        } else if (['mp4', 'mu38', 'm4v'].indexOf(ext.toLowerCase()) !== -1) {
          return 2
        } else if (['mp3', 'wav'].indexOf(ext.toLowerCase()) !== -1) {
          return 1
        }

      }
      if (tupian != 2) {
        this.disbtn = false
      } else {
        this.hadposterurl = a.url
      }

    },
    downexe () {
      console.log(1)
      window.location.href = 'https://wjdayly.obs.cn-jssz1.ctyun.cn:443/apk/Video.exe'
    },
    tabPD (index, item) {
      console.log(item.name, 'item')
      this.queryData[0] = 'circleManager/getQueryList?status=-1&rootid=paike'
      this.curIndex = index
      this.curTabName = item.name
      this.searchParam.classid = item.guid
      this.searchData()
    },
    getpdData () {
      var that = this
      this.axios.get('dic/getQueryList', {
        params: {
          rootid: 'paike'
        }
      }).then(res => {

        var allData = {
          name: '全部拍客',
          guid: '',
        }
        res.data.unshift(allData)
        that.formData[1][0]['children'] = res.data
        that.pdData = res.data
        that.queryData[0] = 'circleManager/getQueryList?status=-1&rootid=paike&classid=' + res.data[0]['guid']
        that.searchData()
      })
    },
    searchData () {
      const regex = /%/ig;
      this.searchParam['msgContent'] = encodeURI(this.msg).replaceAll(regex, '\\%')
      this.searchParam['name'] = encodeURI(this.addname).replaceAll(regex, '\\%')


      this.issearch = Math.random()
    },
    sModal (guid) {


      if (this.formData[0][0].indexOf('?') > -1) {
        this.formData[0][0] = this.formData[0][0].split('?')[0]
      }
      this.formData[0][0] = this.formData[0][0] + '?id=' + guid
      if (guid == -1) {
        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
      }
      this.reloadTmep = Math.random()
    },

    reloadpdTable () {
      this.ispdsearch = Math.random()
    },
    reloadTable () {
      this.issearch = Math.random()
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
}

.demo-upload-list {
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
  margin-right: 0px;
}

#pdData {
  display: flex;
  justify-content: flex-start;
}

.itempd {

  height: 32px;
  line-height: 32px;
  border-radius: 20px;
  padding: 0 15px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer
}

.itempd.active {
  background-color: #00d186;
  border-color: #00d186;
  color: #fff;
}

.newPDvideo {
  text-align: right;
  margin: 0px 0px 20px;
}

.remove {
  position: absolute;
  left: 0px;
  top: 0px;
}
</style>
